import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { useFormik } from 'formik';
import React from 'react'

export default function CreateDialog({openCreateStorage, setOpenCreateStorage, handleCreate}) {
    const user = JSON.parse(localStorage.getItem('user'))
      const {
        values,
        errors,
        touched,
        isSubmitting,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
      } = useFormik({
        initialValues: {
          amount: "",
          type: "",
        },
      });

    return (
        <form>
            <Dialog aria-labelledby='dialog-title' onClose={() => setOpenCreateStorage(false)} open={openCreateStorage}>
                <DialogTitle id='dialog-title'>
                    Create Storage
                </DialogTitle>

                <DialogContent>
                <TextField
                    id="amount"
                    type="text"
                    margin="dense"
                    value={values.amount}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    label="Amount"
                />
                {errors.amount && touched.amount && (
                    <p className="error">{errors.amount}</p>
                )}

                <FormControl fullWidth style={{marginTop: '10px'}}>
                    <InputLabel id="type">Type</InputLabel>
                    <Select
                        labelId="type"
                        id="type"
                        value={values.type}
                        label="Type"
                        onChange={handleChange}
                        name="type"
                    >
                        <MenuItem value={"MB"}>MB</MenuItem>
                        <MenuItem value={"GB"}>GB</MenuItem>
                        <MenuItem value={"TB"}>TB</MenuItem>
                    </Select>
                </FormControl>
                </DialogContent>

                <DialogActions>
                    <Button
                        color="secondary"
                        onClick={() => {
                            setOpenCreateStorage(false)
                            values.amount = ""
                            values.type = ""
                        }}
                        variant="contained"
                    >Cancel</Button>
                    <Button
                        color="primary"
                        onClick={() => {
                            //create new amount
                            handleCreate(values)
                            //reset amount name value
                            values.amount = ""
                            values.type = ""
                        }}
                        variant="contained"
                        >Yes</Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}